import classNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'
import { FormRow } from './form_row.jsx'

export const FormHeader = ({ className, ...props }) => {
  const classes = classNames('heading', className);
  return (
    <FormRow {...props} className={classes} />
  )
}

FormHeader.propTypes = {
  className: PropTypes.string,
  labelClassName: PropTypes.string,
  labelElement: PropTypes.string,
  title: PropTypes.string,
  tooltip: PropTypes.string,
  tooltipUrl: PropTypes.string,
  tooltipLabel: PropTypes.string,
  required: PropTypes.bool,
  wrapperElement: PropTypes.string
}
